import { Chip } from '@/shared/ui/chip'

interface TagChipsProps {
  tags?: string[] | undefined
  /** Клик по тегу (фильтр/поиск). Без него чипы статичны. */
  onTagClick?: (tag: string) => void
  /** Максимум видимых тегов; остаток сворачивается в неинтерактивный «+N». */
  max?: number
  className?: string
}

// Ряд тег-чипов read-view. Кликабельный вариант — кнопка внутри чипа со
// stopPropagation: чипы живут внутри карточек-ссылок и drag-плиток. При max
// показываем первые N и «+K» на остаток (узкая плитка доски).
export function TagChips({ tags, onTagClick, max, className }: TagChipsProps) {
  if (!tags || tags.length === 0) return null
  const shown = max != null ? tags.slice(0, max) : tags
  const overflow = tags.length - shown.length
  return (
    <span className={className ?? 'flex flex-wrap items-center gap-1.5'}>
      {shown.map((tag) => (
        <Chip key={tag} variant="soft" className={onTagClick ? 'p-0' : undefined}>
          {onTagClick ? (
            <button
              type="button"
              onClick={(e) => {
                e.stopPropagation()
                onTagClick(tag)
              }}
              className="px-2.5 py-1 transition-colors hover:text-text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-border-accent"
            >
              {tag}
            </button>
          ) : (
            tag
          )}
        </Chip>
      ))}
      {overflow > 0 && (
        <Chip
          variant="soft"
          className="text-text-tertiary"
          title={tags.slice(shown.length).join(', ')}
        >
          +{overflow}
        </Chip>
      )}
    </span>
  )
}
